import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import AStockComp from '../pages/aStock/index.vue';
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'AStock',
    component: AStockComp,
  },
  {
    path: '/aStock',
    name: 'AStock',
    component: AStockComp,
  },
  {
    path: '/hkStock',
    name: 'HkStock',
    component: () => import(/* webpackChunkName: "HkStock" */ '../pages/hkStock/index.vue'),
  },
  {
    path: '/newStock',
    name: 'newStock',
    component: () => import(/* webpackChunkName: "newStock" */ '../pages/newThreePlate/index.vue'),
  }
];

const router = new VueRouter({
  routes,
});

export default router;
